











import { Prop, Component, Vue, Watch } from "vue-property-decorator";
import {
  getConstructionTask,
  SaveConstructionTaskCommand
} from "../../api/construction-task-api";
import ConstructionTaskForm from "../components/ConstructionTaskForm.vue";
import SwitchButton from "../../../components/SwitchButton.vue";

/**
 * 社内タスクの編集ページ
 */
@Component({
  components: {
    SwitchButton,
    ConstructionTaskForm
  }
})
export default class ConstructionTaskEditPage extends Vue {
  @Prop({ required: true }) id!: string;

  defaultValues: SaveConstructionTaskCommand = {
    name: "",
    shortName: "",
    alignment: "0",
    clear: "0",
    serviceTaskTypeId: "0"
  };

  @Watch("id", { immediate: true })
  onIdChanged(id: string) {
    this.edit(Number(id));
  }

  async edit(id: number) {
    const task = await getConstructionTask(id);
    if (!task) {
      throw new Error(`construction task is not found: ${id}`);
    }
    this.defaultValues = {
      ...task,
      alignment: String(task.turn),
      serviceTaskTypeId: String(task.serviceTaskTypeId),
      clear: String(task.clear)
    };
  }

  goListPage() {
    this.$router.push({ name: "construction-task-list" });
  }
}
